import { useTranslation } from "react-i18next"
import { useState, useCallback } from 'react';

import PageWrapper from "components/page/PageWrapper"
import TabBar from "components/tabbar/TabBar";
import Company from "components/company/Company";

import bg from 'assets/images/banner/banner02.jpg'

import ProductHd from './ProductHd';
import ProductJi from './ProductJi';
import ProductTr from'./ProductTr';
import ProductLo from './ProductLo';
import ProductQc from './ProductQc';

export default function Modules(){
  const {t} = useTranslation();
  const menuName= t('menu.sub-modules');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/modules', name:menuName}];
  const title = t('modules.banner.title')
  const comment = t('modules.banner.comment')

  const tabs = [
    t('modules.tabs.name-1'),
    t('modules.tabs.name-2'),
    t('modules.tabs.name-3'),
    t('modules.tabs.name-4'),
    t('modules.tabs.name-5')
  ];
  const prefix = ['qc', 'hd', 'tr', 'lo', 'ji'];
  const width = [135, 243, 148, 182, 152];
  const [index, setIndex] = useState(0);
  const handleClick = useCallback((index)=>{
    setIndex(index);
  }, [setIndex]);

  const products = [
    <ProductQc/>,
    <ProductHd/>,
    <ProductTr/>,
    <ProductLo/>,
    <ProductJi/>
  ]

    return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className='flex flex-col w-full lg:items-center'>
        <TabBar tabs={tabs} callback={handleClick} selected={index} className='px-mobile lg:px-0'/>
        {index===3? 
        (
          <>
          <Company module={'modules'} prefix={prefix[index]} index={index} ciWidth={width[index]} reverse={true} className='px-mobile lg:px-0'/>
          <Company module={'modules'} prefix={prefix[index]} index={index} ciWidth={0} className='px-mobile lg:px-0'
            title={'modules.company.lo.title-2'} 
            comment={'modules.company.lo.comment-2'} 
            img={'company_2.jpg'}/>
          </>
        )
        : 
          <Company module={'modules'} prefix={prefix[index]} index={index} ciWidth={width[index]} className='px-mobile lg:px-0'/>
        }
        
        {products[index]}
      </div>
    </PageWrapper>
  );
}